module.exports = __webpack_public_path__ + "img/Icon_Mail.e49abef7.svg";